var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { StepLayout } from '@/components/step-layout.component';
import { pageImages } from '@/pages/images';
import { NavigationButton, NavigationButtonsContainer, } from '@/components/navigation-button.component';
import { Typography } from '@mui/material';
import { HeadphoneCheckContent } from './headphone-check-content.component';
export function HeadphoneCheck() {
    return (_jsx(StepLayout, { image: pageImages.manListeningIntently, heading: _jsx(Typography, __assign({ variant: "h3", className: "md:pt-6 lg:pt-12 xl:pt-[72px] font-extrabold text-charcoal text-2xl lg:text-4xl" }, { children: "Which ear do you hear the sound in?" })), progress: { phase: 0, step: 5 }, content: _jsx(HeadphoneCheckContent, {}), nav: _jsx(NavigationButtonsContainer, __assign({ className: 'mb-6' }, { children: _jsx(NavigationButton, { type: "back", variant: "outlined", label: "Previous" }) })) }));
}
;
